import { useLocation } from 'react-router';

import { useGetPracticeGroups } from '@/react-query/insights/usePracticeGroups';

import { AIOppAvailableChart } from '../../charts/AIOppAvailableChart';
import { AIViewRateChart } from '../../charts/AIViewRateChart';
import { ConversionRateChart } from '../../charts/ConversionRateChart';
import { mapRates } from '../../helpers/benchmarking/mapRates';
import { usePracticeRates } from '../../helpers/benchmarking/practiceRates';
import { RegionHeader } from '../RegionHeader';

import { RegionBenchmarksTable } from './RegionBenchmarksTables';

export const RegionBenchmarks = () => {
  const location = useLocation();
  const id =
    location.pathname.split('region/')[1]?.split('/')[0] === 'undefined'
      ? undefined
      : location.pathname.split('region/')[1]?.split('/')[0];

  const { data: practiceGroups } = useGetPracticeGroups();
  const selectedPractices = practiceGroups?.data
    .find((group) => group.id.toString() === id)
    ?.practices.map((practice) => practice.practiceVideaId);

  const practiceRates = usePracticeRates({
    practices: selectedPractices,
  });

  return (
    <div className="vai-flex vai-flex-col vai-gap-4 vai-w-full vai-px-8 vai-py-4">
      <RegionHeader />
      <div className="vai-flex vai-flex-row vai-justify-between vai-w-full vai-h-full">
        <div className="vai-flex vai-flex-col vai-w-[33%] vai-gap-4">
          <AIOppAvailableChart practices={selectedPractices} />
          <AIViewRateChart practices={selectedPractices} />
        </div>

        <ConversionRateChart level="Region" practices={selectedPractices} />
      </div>
      <RegionBenchmarksTable
        data={
          practiceRates.practiceRates?.map((practice) =>
            mapRates(practice, practice.practiceId, practice.practiceName),
          ) ?? []
        }
        isLoading={practiceRates.isLoading}
        regionName={
          practiceGroups?.data.find((g) => g.id.toString() === id)?.name
        }
      />
    </div>
  );
};
